var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradesFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.691 0H5.31C2.27 0 0.5 1.78 0.5 4.83V15.16C0.5 18.26 2.27 20 5.31 20H13.691C16.78 20 18.5 18.26 18.5 15.16V4.83C18.5 1.78 16.78 0 13.691 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57999 4.65039V4.66039C5.14899 4.66039 4.79999 5.01039 4.79999 5.44039C4.79999 5.87039 5.14899 6.22039 5.57999 6.22039H8.56899C8.99999 6.22039 9.34999 5.87039 9.34999 5.42939C9.34999 5.00039 8.99999 4.65039 8.56899 4.65039H5.57999ZM13.42 10.7404H5.57999C5.14899 10.7404 4.79999 10.3904 4.79999 9.96039C4.79999 9.53039 5.14899 9.17939 5.57999 9.17939H13.42C13.85 9.17939 14.2 9.53039 14.2 9.96039C14.2 10.3904 13.85 10.7404 13.42 10.7404ZM13.42 15.3104H5.57999C5.27999 15.3504 4.98999 15.2004 4.82999 14.9504C4.66999 14.6904 4.66999 14.3604 4.82999 14.1104C4.98999 13.8504 5.27999 13.7104 5.57999 13.7404H13.42C13.819 13.7804 14.12 14.1204 14.12 14.5304C14.12 14.9294 13.819 15.2704 13.42 15.3104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradesFilled);
export default __webpack_public_path__ + "static/media/trades_filled.6253b62b5ce61b473497d4e1493526e5.svg";
export { ForwardRef as ReactComponent };